/** Una domanda per card: titolo bold 800, un solo colore, nessun pretitolo (DEC-10). */
import type { ReactNode } from 'react'

export type QuestionTitleProps = {
  children: ReactNode
  /** h1 nella card del wizard; h2 quando la card vive dentro una pagina con un suo titolo. */
  as?: 'h1' | 'h2'
  id?: string
}

export function QuestionTitle({ children, as: Tag = 'h1', id }: QuestionTitleProps) {
  return (
    <Tag
      id={id}
      className="mb-[14px] text-title text-ink"
      style={{ fontWeight: 'var(--type-title-weight)' as never }}
    >
      {children}
    </Tag>
  )
}
